import React from 'react';
import { commonStyles, designTokens } from 'utils/designSystem';

const DateRangeField = ({ 
  label, 
  startValue, 
  endValue, 
  onStartChange, 
  onEndChange, 
  maxDate 
}) => {
  const formatDateForInput = (date) => {
    if (!date) return '';
    const d = new Date(date);
    return `${d.getFullYear()}-${(d.getMonth() + 1).toString().padStart(2, '0')}-${d.getDate().toString().padStart(2, '0')}`;
  };

  const maxDateStr = maxDate ? formatDateForInput(maxDate) : undefined;

  return (
    <div style={commonStyles.formField}>
      {label && <label style={commonStyles.formLabel}>{label}</label>}
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: designTokens.spacing.sm
      }}>
        <input
          type="date"
          value={startValue}
          onChange={(e) => onStartChange(e.target.value)}
          max={maxDateStr}
          style={commonStyles.input}
        />
        <span style={{ color: designTokens.colors.text.tertiary }}>~</span>
        <input
          type="date"
          value={endValue}
          onChange={(e) => onEndChange(e.target.value)}
          max={maxDateStr}
          style={commonStyles.input}
        />
      </div>
    </div>
  );
};

export default DateRangeField;